export default Object.freeze({
  SelfService: 1,
  RequiresAutomyApproval: 2,
  AutomyOnly: 3,
});
